define('SC.SummitThemeExtension.ErrorManagement', [
  'underscore',
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.LayoutHelper'
], function SummitThemeExtensionErrorManagement(
  _,
  Configuration,
  LayoutHelper
) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'ErrorManagement.PageNotFound.View',
        'errorManagement',
        'object',
        function () {
          return {
            backgroundImage: _.getAbsoluteUrl(
              Configuration.get(
                'errorManagementPageNotFound.pageNotFoundBgrImg'
              )
            ),
            backgroundColor: Configuration.get(
              'errorManagementPageNotFound.bkgdColor'
            ),
            title: Configuration.get('errorManagementPageNotFound.title'),
            text: Configuration.get('errorManagementPageNotFound.text'),
            btnText: Configuration.get('errorManagementPageNotFound.btnText'),
            btnHref: Configuration.get('errorManagementPageNotFound.btnHref')
          };
        }
      );
    }
  };
});
